import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';
import theme from 'theme';

const terminalValueListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    textAlign: 'right',
    fontWeight: 700,
  }),
  menu: styles => ({
    ...styles,
    right: 0,
    marginTop: `-${theme.palette.headerCellHeight}`,
  }),
};

export default terminalValueListStyles;
